module.exports = __webpack_public_path__ + "static/media/Sid Bhatia.06e79297.jpg";